import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getStylesheetFromRawCss } from 'utils';
import useDangerousDimensions from './use-dangerous-dimensions';

// eslint-disable-next-line import/no-unresolved
import rawCss from '!!raw-loader!./style.module.css';
import style from './style.module.css';

const OverlayNode = forwardRef(function Overlay(
  { tagName, className, type, children, element, document, ...rest },
  ref
) {
  const customClassName = classNames(
    style['overlay-node'],
    className,
    style[`-${type}`]
  );

  const { width, height, top, left } = useDangerousDimensions({
    element,
    document,
  });

  const position = {
    width: `${width}px`,
    height: `${height}px`,
    top: `${top}px`,
    left: `${left}px`,
  };

  const stylesheet = getStylesheetFromRawCss(style, rawCss);

  return (
    <div ref={ref} style={position} className={customClassName} {...rest}>
      <style>{stylesheet}</style>
      <div>
        {tagName && <span>{tagName}</span>}
        {children}
      </div>
    </div>
  );
});

OverlayNode.propTypes = {
  type: PropTypes.oneOf(['highlight', 'dashed']),
  element: PropTypes.shape({}).isRequired,
  document: PropTypes.shape({}),
  children: PropTypes.node,
  className: PropTypes.string,
  tagName: PropTypes.string,
};

OverlayNode.defaultProps = {
  document,
  type: 'dashed',
  children: null,
  className: null,
  tagName: null,
};

export default OverlayNode;
